import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { HugeiconsIcon } from '@hugeicons/react';
import cn from 'classnames';
import FeatherIcon from 'feather-icons-react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import styles from './IconButton.module.scss';

export const IconButton = ({
  icon,
  className,
  tip,
  placement = 'top',
  prefix = 'fi',
  active = false,
  disabled = false,
  small = false,
  type = 'default',
  elevated = false,
  onClick = () => {},
}) => (
  <OverlayTrigger
    trigger={tip === undefined ? 'none' : ['hover', 'focus']}
    placement={placement}
    overlay={<Tooltip>{tip}</Tooltip>}>
    <div
      className={cn(styles.root, styles[type], {
        [className]: className,
        [styles.rootSmall]: small,
        [styles.rootDisabled]: disabled,
        [styles.rootActive]: active,
        ['disabled']: disabled,
        ['u-drop-shadow--medium']: elevated,
      })}
      onClick={e => !disabled && onClick(e)}>
      {prefix === 'fa' ? (
        <FontAwesomeIcon icon={icon} />
      ) : prefix === 'hugeicons' ? (
        <HugeiconsIcon size={17} icon={icon} className={styles.icon} strokeWidth={2} />
      ) : (
        <FeatherIcon size={17} icon={icon} className={styles.icon} />
      )}
    </div>
  </OverlayTrigger>
);

IconButton.propTypes = {
  icon: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
};
